module.exports = __webpack_public_path__ + "static/media/bye5.dea757ac.gif";